import * as React from 'react';
import Switch from '@mui/material/Switch';

interface SwitchesProps {
  checked: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function Switches({ checked, handleChange }: SwitchesProps) {
  return <Switch checked={checked} onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} />;
}